import api from "./../api"; 
import { useCallback } from "react";

export const useFinanzasINMOB = () => {

  const getFinanzasUltimoPeriodo = async () => {
    try {
      const { data } = await api.get("/inmobiliaria/resumenUltimoPeriodo");
      return data;
    } catch (error) {
      console.error("Error al traer finanzas:", error);
      throw error.response?.data?.message || "Error al cargar finanzas";
    }
  };

  const getFinanzasPorPeriodo = async () => {
    try {
      const { data } = await api.get("/inmobiliaria/resumenPorPeriodos");
      return data;
    } catch (error) {
      console.error("Error al traer finanzas:", error);
      throw error.response?.data?.message || "Error al cargar finanzas";
    }
  };
   const getFinanzasUltimoPeriodoMontoNeto = async () => {
    try {
      const { data } = await api.get("/inmobiliaria/resumenUltimoPeriodoMontoNeto");
      return data;
    } catch (error) {
      console.error("Error al traer finanzas:", error);
      throw error.response?.data?.message || "Error al cargar finanzas";
    }
  };

  const getFinanzasPorPeriodoMontoNeto = async () => {
    try {
      const { data } = await api.get("/inmobiliaria/resumenPorPeriodosMontoNeto");
      return data;
    } catch (error) {
      console.error("Error al traer finanzas:", error);
      throw error.response?.data?.message || "Error al cargar finanzas";
    }
  };
  
  
  return {
    getFinanzasUltimoPeriodo,
    getFinanzasPorPeriodo,
    getFinanzasUltimoPeriodoMontoNeto,
    getFinanzasPorPeriodoMontoNeto
  };
}


